<!--
   Created by qing on 2020/9/11
   Des:
-->
<template>
	<div class="log-component-container">

		<div class="sub-header-container">
			<div
				v-if="showLog"
				class="todo-filter-item"
				@click="onClickDynamicTag('log')"
				:class="{'active': selectedDynamicType === 'log'}"
			>
				流程日志
			</div>
			<div
				v-if="showApply"
				class="todo-filter-item"
				:class="{'active': selectedDynamicType === 'comment'}"
				@click="onClickDynamicTag('comment')"
			>
				审批意见
			</div>
			<div
				v-if="showDynamic"
				class="todo-filter-item"
				:class="{'active': selectedDynamicType === 'dynamic'}"
				@click="onClickDynamicTag('dynamic')"
			>
				历史动态
			</div>
			<div
				v-if="showComment"
				class="todo-filter-item"
				:class="{'active': selectedDynamicType === 'discuss'}"
				@click="onClickDynamicTag('discuss')"
			>
				评论
			</div>
		</div>

		<div
			class="log-container"
			v-if="selectedDynamicType === 'log'"
		>
			<template v-if="currentFormDetail && currentFormDetail.flowLogList.length">
				<van-steps
					v-if="currentFormDetail"
					direction="vertical"
					:active="currentFormDetail.flowLogList.length - 1"
				>
					<van-step
						v-for="(item, index) in currentFormDetail.flowLogList"
						:key="index"
					>
						<p class="dete-tx">{{formatDate(item.handleTime)}}</p>
						<div
							class="log-item-container"
							v-if="item.stepStatus !== 'END'"
						>
							<div class="log-item-header">
								<strong>{{item.stepName}}</strong>
								<van-tag
									:color="stepStatusMap[item.stepStatus].color"
									:text-color="stepStatusMap[item.stepStatus].textColor"
								>
									{{stepStatusMap[item.stepStatus].name || ''}}
								</van-tag>
							</div>

							<div class="handle-user-container">
								<!--<h6>处理人</h6>-->
								<div>
									<van-image
										width="26"
										height="26"
										round
										fit="cover"
										:src="item.headImg + '?imageView2/0/w/26/h/26'"
									>
									</van-image>
									<div>
										<strong>{{item.handleDetail}}</strong>
									</div>
								</div>
								<van-button
									type="success"
									size="mini"
									plain
									@click="onClickLogDetail(item)"
								>
									<img src="../../assets/images/btn-icon.png" >
									{{item.editFieldList.length}}
								</van-button>
							</div>
							<div
								v-if="item.costTimeStr"
								class="cost-time-container"
							>
								耗时：{{item.costTimeStr}}
							</div>
						</div>
						<div
							class="log-item-container"
							v-if="item.stepStatus === 'END'"
						>
							<div class="log-item-header">
								<strong>{{item.stepName}}</strong>
							</div>

							<div
								class="handle-user-container"
								style="justify-content: flex-start;"
							>
								<van-icon
									name="certificate"
									color="#4fc08d"
									size="20"
								>
								</van-icon>
								流程结束
							</div>
							<div
								v-if="item.costTimeStr"
								class="cost-time-container"
							>
								耗时：{{item.costTimeStr}}
							</div>
						</div>
					</van-step>
				</van-steps>

				<van-popup
					class="log-detail-popup"
					v-model="showLogDetail"
					round
					closeable
					position="bottom"
					get-container="body"
					:style="{ height: '90%' }"
				>
					<div
						class="edit-field-container"
						:key="logDetailKey"
					>
						<div
							class="edit-field-item"
							v-for="item in editFieldList"
							:key="Math.random()"
						>
							<div>{{item.fieldName}}</div>
							<div class="field-content">
								<strong>修改前:</strong>
								<span>{{valueFormatter(item.fieldId, item.oldValue)}}</span>
							</div>
							<div class="field-content">
								<strong>修改后: </strong>
								<span>{{valueFormatter(item.fieldId, item.newValue)}}</span>
							</div>
						</div>
					</div>
				</van-popup>
			</template>
			<div
				class="dynamic-empty"
				v-else
			>
				暂无流程日志
			</div>
		</div>

		<template v-if="selectedDynamicType === 'comment'">

			<div
				class="approve-container"
				v-if="approveComment && approveComment.length"
			>
				<div
					class="comment-item"
					v-for="item in approveComment"
					:key="Math.random()"
				>
					<el-avatar :src="item.headImage">
					</el-avatar>
					<div class="comment-content">
						<div class="user-info">
							<div style="display: flex; align-items: center;">
								<div class="name">{{item.userName}}</div>
								<span
									v-if="item.buttonName"
									style="margin-left: 10px; padding: 2px 4px; border-radius: 2px"
									:style="{color: handleActionMap[item.handleAction] ? handleActionMap[item.handleAction].customColor : '', border: `1px solid ${handleActionMap[item.handleAction] ? handleActionMap[item.handleAction].customColor : ''}`}"
								>
									{{item.buttonName}}
								</span>
							</div>
							<div class="time">{{formatDate(item.timestamp)}}</div>
						</div>
						<div class="comment-info">
							<div class="comment-text">
								{{item.comment}}
							</div>
							<el-image
								class="sign-image"
								v-if="item.signatureUrl"
								:src="item.signatureUrl"
							>
							</el-image>
						</div>
					</div>
				</div>
			</div>
			<div
				class="dynamic-empty"
				v-else
			>
				暂无审批意见
			</div>
		</template>

		<template v-if="selectedDynamicType === 'dynamic'">
			<div
				class="dynamic-container"
				v-if="dataDynamic && dataDynamic.length"
			>
				<div
					class="dynamic-item"
					v-for="item in dataDynamic"
					:key="Math.random()"
				>
					<el-avatar :src="item.headImg">
					</el-avatar>
					<div class="dynamic-content">
						<div class="user-info">
							<div>
								<div class="name">{{item.userName}}</div>
								<div class="status">{{item.updateType ? '更新状态' : '修改'}}</div>
							</div>
							<div class="time">{{formatDate(item.createTime)}}</div>
						</div>
						<div style="margin-top: 5px; color: #6ca2ff;">
							{{item.scene}}
						</div>
						<div class="dynamic-info">
							<div
								class="dynamic-info-line"
								v-for="dynamic in item.updateFieldList"
								:key="dynamic.fieldId"
							>

								<div v-if="dynamic.type !== FORM_ITEM__TABLE">
									{{dynamic.fieldName}}：{{fieldValueToString(dynamic.fieldId, dynamic.newValue, null)}}
								</div>

								<div v-if="dynamic.type === FORM_ITEM__TABLE">
									{{dynamic.fieldName}}：
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div
				class="dynamic-empty"
				v-else
			>
				暂无历史动态
			</div>
		</template>

		<template v-if="selectedDynamicType === 'discuss'">

			<div class="comment-container">

				<div class="comment-list-container">
					<div
						class="discuss-header"
						v-if="!$store.getters.isGuest"
					>

						<ContactBox
							key="subscribeContactBox"
							fieldId="subscribeContactBox"
							:field="chargeUserConfig"
							:user-id="$store.state.userId"
							:company-id="$store.state.companyId"
							:hasDep="false"
							:hasRole="false"
							:has-label="false"
							:has-current="false"
							:multiple="true"
							:selectedMember="subscribeMemberList"
							:selected-ext="subscribeExtList"
							@deleteUser="deleteSubscribeUser"
							@selectedComplete="updateSubscribeList"
						>
						</ContactBox>

						<van-button
							class="subscribe-button"
							plain
							hairline
							type="info"
							size="small"
							@click="subscribeVisible = true"
						>
							{{subscribe ? '已订阅' : '未订阅'}}
						</van-button>

						<van-dialog
							class="subscribe-setting-popover"
							v-model="subscribeVisible"
							:showConfirmButton="false"
							:closeOnClickOverlay="true"
							get-container="body"
						>
							<div style="width: 100%; padding: 10px">
								<div class="subscribe-setting-container">
									<div
										class="subscribe-setting-item"
										@click="onClickSubscribeChange('CLOSE')"
									>
										<div class="subscribe-setting-title">
											<i
												class="el-icon-check"
												:style="{opacity: subscribe ? 0 : 1,  color: subscribe ? '' : '#1b9aee'}"
											></i>
											<div>
												未订阅
											</div>
										</div>
										<div class="subscribe-setting-tips">
											当有人@您时才会收到通知
										</div>
									</div>
									<div
										style="width: 100%; height: 1px; background-color: #959699; margin-bottom: 10px;">
									</div>
									<div
										class="subscribe-setting-item"
										@click="onClickSubscribeChange('OPEN')"
									>
										<div class="subscribe-setting-title">
											<i
												class="el-icon-check"
												:style="{opacity: subscribe ? 1: 0, color: subscribe ? '#1b9aee' : ''}"
											></i>
											<div>
												订阅
											</div>
										</div>
										<div class="subscribe-setting-tips">
											当有人在该数据评论时您就会收到通知
										</div>
									</div>
								</div>
							</div>
						</van-dialog>
					</div>
					<template v-if="commentData && commentData.length">

						<div
							class="comment-list-item"
							v-for="(item, idx) in commentData"
							v-if="!item.deleteFlag"
							:key="item.commentId"
						>
							<div class="user-img">
								<van-image
									round
									style="width: 30px; height: 30px;"
									:src="item.headImage"
								></van-image>
							</div>
							<div class="comment-info">
								<div class="top">
									<div class="user-info">
										<div>
											{{item.userName}}
										</div>
										<div>
											{{actionFormatTime(item.commentTime)}}
										</div>
									</div>
									<div
										class="comment-handle"
										v-if="!$store.getters.isGuest"
									>
										<div
											class="handle-button"
											@click.stop.prevent.left="replyComment(item)"
										>
											回复
										</div>
										<div
											v-if="item.userId === $store.getters.userId"
											class="handle-button"
											@click.stop.prevent.left="editComment(item)"
										>
											编辑
										</div>
										<div
											v-if="item.userId === $store.getters.userId"
											class="handle-button"
											style="color: red;"
											@click.stop.prevent.left="deleteComment(item, idx)"
										>
											删除
										</div>
									</div>
								</div>
								<div
									class="reply-container"
									v-if="fetchSourceComment(item.replyId)"
									@click.stop="onClickComment(item)"
								>
									<div class="line"></div>
									<div class="reply-content">
										回复&nbsp;&nbsp;{{fetchSourceComment(item.replyId).userName}}:&nbsp;{{fetchSourceContent(item.replyId)}}
									</div>
								</div>

								<div class="comment-detail">
									<div
										v-if="item.content"
										class="comment-content ql-editor"
										v-html="formatCommentContent(item)"
									></div>

									<ul class="file__list">
										<li v-for="(file, idx) in item.attachmentList">
											<div class="file__icon">
												<svg
													class="icon"
													aria-hidden="true"
												>
													<use :xlink:href="actionFileType2FileImage(file.fileType)"></use>
												</svg>
											</div>
											<div class="file__info">
												<div class="file__info-name">
													{{file.fileName}}
												</div>
												<div class="file__info-bottom">

													<div class="file__info-size">
														{{file.fileSize}}KB
													</div>
													<div
														class="file__info-handle"
														v-if="!$store.getters.isGuest"
													>
														<div
															class="handle-button"
															@click.stop.prevent.left="previewFile(item.attachmentList, file)"
														>
															预览
														</div>
														<div class="divider"></div>
														<div
															class="handle-button"
															@click.stop.prevent.left="downloadFile(file)"
														>
															下载
														</div>
														<div class="divider"></div>
														<div
															v-if="item.userId === $store.getters.userId"
															class="handle-button"
															@click="openFileAccessRecords(file.fileUrl)"
														>
															访问记录
														</div>
													</div>
												</div>
											</div>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</template>

					<div
						class="dynamic-empty"
						v-else
					>
						写下第一条评论吧~
					</div>
				</div>


				<div class="comment-input">

					<FormCommentInput
						v-if="!$store.getters.isGuest"
						ref="commentInput"
						:instanceId="instanceId"
						:viewId="viewId"
						:stepId="stepId"
						:commentLocation="commentLocation"
						commentType="INSTANCE"
						:chargeUserConfig="chargeUserConfig"
						:atUserConfig="atUserConfig"
						:fetchSourceContent="fetchSourceContent"
						@focusComment="focusComment"
						@submitCommentComplete="submitComment"
					></FormCommentInput>
				</div>


				<file-access-records
					ref="fileAccessRecords"
					popupHeight="90%"
					position="bottom"
					:overlay="true"
					:stackList="stackList"
				></file-access-records>

				<file-preview-popup
					ref="filePreviewPopup"
					popupHeight="90%"
					position="bottom"
					:overlay="true"
					:stackList="stackList"
				></file-preview-popup>

				<!--评论回复列表-->
				<CommentReplyList
					ref="commentReplyList"
					:instanceId="instanceId"
					:viewId="viewId"
					:stepId="stepId"
					:commentLocation="commentLocation"
					commentType="INSTANCE"
					@reply-close="replyListClose"
				></CommentReplyList>
			</div>
		</template>
		<gallery
			id="comment"
			:images="previewData"
			:index="index"
			@close="index = null"
		></gallery>
	</div>
</template>

<script>
	import {
		accurateFormatDate,
		fileType2FileImage,
		getSimpleText,
		clone,
		arrayRemove
	} from "../../assets/js/Untis"
	import {
		FORM_ITEM__TABLE
	} from "../RyForm/types";
	import FormCommentInput from "./FormCommentInput";
	import FileAccessRecords from "./mix_form/FileAccessRecords";
	import FilePreviewPopup from "./mix_form/FilePreviewPopup";
	import CommentReplyList from "./mix_form/CommentReplyList";
	import VueGallery from 'vue-gallery';

	export default {
		props: {
			tabActive: {
				type: String,
				default: ''
			},
			appId: {
				type: String,
				default: ''
			},
			// 表单id
			formId: {
				type: String,
				default: ''
			},
			// 是否展示流转日志
			showLog: {
				type: Boolean,
				default: true
			},
			showApply: {
				type: Boolean,
				default: true
			},
			showComment: {
				type: Boolean,
				default: true
			},
			// 是否展示数据动态
			showDynamic: {
				type: Boolean,
				default: true
			},
			instanceId: {
				type: String,
				default: ''
			},
			viewId: {
				type: String,
				default: ''
			},
			commentLocation: {
				type: String,
				default: ''
			},
			stepId: {
				type: String,
				default: ''
			},
			formSet: Object,
			chargeUserConfig: {
				type: Object,
				default: () => {
					return {
						showContact: false
					}
				}
			},
			atUserConfig: {
				type: Object,
				default: () => {
					return {
						showContact: false
					}
				}
			},
			isLink: {
				type: Boolean,
				default: false
			}
		},
		components: {
			FormCommentInput,
			FileAccessRecords,
			FilePreviewPopup,
			CommentReplyList,
			'gallery': VueGallery
		},
		data() {
			return {
				FORM_ITEM__TABLE,
				selectedDynamicType: 'log',

				currentFormDetail: null,
				dataDynamic: [],
				approveComment: [],
				commentData: [],
				subscribeVisible: false,
				subscribe: 0, // 订阅关系
				subscribeMemberList: [], // 订阅人员IdList
				subscribeExtList: [], // 订阅人员IdList
				stackList: [],
				downloadEle: null,

				// 步骤状态map
				stepStatusMap: {
					INIT: {
						textColor:'#4260FA',
						color:'#ECEFFE',
						name: '发起'
					},
					NOT_START: {
						textColor:'#FF8107',
						color:'#FFF2E6',
						name: '未开始'
					},
					RUNNING: {
						textColor:'#4260FA',
						color:'#ECEFFE',
						name: '进行中'
					},
					FINISH: {
						textColor:'#01D6B9',
						color:'#E3F6F3',
						name: '完成'
					},
					REJECT: {
						textColor:'#FF8107',
						color:'#FFF2E6',
						name: '拒绝'
					},
					REPULSE: {
						textColor:'#FF8107',
						color:'#FFF2E6',
						name: '驳回'
					},
					REVOCATION: {
						textColor:'#FF8107',
						color:'#FFF2E6',
						name: '撤回',
						color: 'danger'
					},
					STOP_KILL: {
						textColor:'#FF8107',
						color:'#FFF2E6',
						name: '结束秒杀'
					}
				},

				handleActionMap: {
					// 提交
					submit: {
						originName: "submit",
						customName: "提交",
						customColor: "#1CA04E",
					},
					// 同意
					agree: {
						originName: "agree",
						customName: "同意",
						customColor: "#1CA04E",
					},
					// 暂存
					drafts: {
						originName: "drafts",
						customName: "暂存",
						customColor: "#f4f4f4",
					},
					// 拒绝
					reject: {
						originName: "reject",
						customName: "拒绝",
						customColor: "#FF442F",
					},
					// 转交
					forward: {
						originName: "forward",
						customName: "转交",
						customColor: "#f0a500",
					},
					// 驳回
					repulse: {
						originName: "repulse",
						customName: "驳回",
						customColor: "#FF442F",
					},
					// 丢弃
					discard: {
						originName: "discard",
						customName: "丢弃",
						customColor: "#f0a500",
					},

					// 撤回
					revocation: {
						originName: "revocation",
						customName: "撤回",
						customColor: "#FF442F",
					},

					// 提交并打印
					submitAndPrint: {
						originName: "submitAndPrint",
						customName: "打印",
						customColor: "#1CA04E",
					},

					// 秒杀
					secKill: {
						originName: "secKill",
						customName: "秒杀",
						customColor: "#FF442F",
					},
					// 结束秒杀
					stopKill: {
						originName: "stopKill",
						customName: "结束秒杀",
						customColor: "#1CA04E",
					},
				},
				// 展示流转日志中的修改详情
				showLogDetail: false,
				logDetailKey: Math.random(),
				// 修改详情list
				editFieldList: [],
				index: null,
				previewData: []
			}
		},
		created() {
			this.downloadEle = document.createElement('a')
			this.downloadEle.setAttribute('target', '_blank')
			this.fetchLog()
			this.fetchDataDynamic()
			this.fetchFormApproveComment()
			this.fetchCommentList()
			if (this.tabActive) {
				this.selectedDynamicType = this.tabActive
			} else {
				if (this.showLog) {
					this.selectedDynamicType = 'log'
				} else if (this.showApply) {
					this.selectedDynamicType = 'comment'
				} else if (this.showDynamic) {
					this.selectedDynamicType = 'dynamic'
				} else if (this.showComment) {
					this.selectedDynamicType = 'discuss'
				}
			}

		},
		methods: {

			actionFormatTime(d) {
				return accurateFormatDate(d)
			},
			actionFileType2FileImage(fileType) {
				return fileType2FileImage(fileType)
			},
			// 点击动态中tag
			onClickDynamicTag(type) {
				this.selectedDynamicType = type
			},

			// 获取流转日志
			fetchLog() {

				let uri = 'actionFetchFormApplyOverview'
				if (this.isLink) {
					uri = 'actionFetchFormApplyLinkOverview'
				}
				this.$store.dispatch(uri, {
					companyId: this.formSet.companyId,
					formId: this.formId,
					appId: this.appId,
					stepId: this.stepId,
					instanceId: this.instanceId
				}).then(info => {
					if (info.flowLogList && info.flowLogList.length > 0) {
						info.flowLogList.forEach((item, idx) => {
							const list = []
							if (item.nextHandle && item.nextHandle.length) {
								const {
									member,
									depart,
									role
								} = item.nextHandle
								member.map(id => {
									const user = this.$store.getters.userListMap[id]
									list.push({
										name: user.nickname,
										img: user.headImg
									})
								})
								role.map(id => {
									const ro = this.$store.getters.roleListMap[id]
									list.push({
										name: ro.roleName,
										img: ''
									})
								})
								depart.map(id => {
									const dep = this.$store.getters.depListMap[id]
									list.push({
										name: dep.depName,
										img: ''
									})
								})
							}
							info.flowLogList[idx].nextHandleList = list
						})
					}
					this.currentFormDetail = info
				})
			},
			// 获取数据动态
			fetchDataDynamic() {

				let uri = 'actionFetchFormDataDynamic'
				if (this.isLink) {
					uri = 'actionFetchFormDataLinkDynamic'
				}
				this.$store.dispatch(uri, {
						companyId: this.formSet.companyId,
						formId: this.formId,
						appId: this.appId,
						instanceId: this.instanceId
					})
					.then(res => {
						this.dataDynamic.splice(0, this.dataDynamic.length, ...res)
					})
					.catch(console.error)
			},

			// 审批意见列表
			fetchFormApproveComment() {

				let uri = 'actionFetchFormApproveComment'
				if (this.isLink) {
					uri = 'actionFetchFormApproveLinkComment'
				}
				this.$store.dispatch(uri, {
						companyId: this.formSet.companyId,
						formId: this.formId,
						appId: this.appId,
						instanceId: this.instanceId
					})
					.then(res => {
						this.approveComment.splice(0, this.approveComment.length, ...res)
					})
					.catch(console.error)
			},

			// 点击查看流转日志中修改详情
			onClickLogDetail(item) {
				this.editFieldList = item.editFieldList
				this.logDetailKey = Math.random()
				this.showLogDetail = true
			},

			// 对比修改内容的表单内容对比table渲染函数
			valueFormatter(fieldId, value) {
				const opts = {
					depList: this.$store.getters.depListMap,
					roleList: this.$store.getters.roleListMap,
					userList: this.$store.getters.userListMap
				}
				return this.formSet.valueToString(fieldId, value, opts)
			},

			// 时间转换方法
			formatDate(d) {
				return accurateFormatDate(d)
			},
			// 对比修改内容的表单内容对比table渲染函数
			tableFormatter(row, col, value, index) {
				const opts = {
					depList: this.$store.getters.depListMap,
					roleList: this.$store.getters.roleListMap,
					userList: this.$store.getters.userListMap
				}
				return this.fieldValueToString(row.fieldId, value, opts)
			},
			fieldValueToString(fieldId, value, opts) {
				return this.formSet ? this.formSet.valueToString(fieldId, value, opts) : ''
			},


			// 首次填写评论
			focusComment() {
				if (this.$refs.commentInput) {
					this.$refs.commentInput.open({
						commentStatus: 'NONE'
					})
				}
			},

			// 回复评论
			replyComment(item) {
				if (this.$refs.commentInput) {
					this.$refs.commentInput.open({
						commentStatus: 'REPLY',
						replyCommentInfo: item
					})
				}
			},
			// 编辑评论
			editComment(item) {
				if (this.$refs.commentInput) {
					this.$refs.commentInput.open({
						commentStatus: 'EDIT',
						commentInfo: clone(item)
					})
				}
			},
			deleteComment(item) {
				this.$dialog.confirm({
						title: '提示',
						message: '删除评论后将无法恢复，是否删除？',
						confirmButtonText: '删除',
						confirmButtonColor: '#ed3f14',
						cancelButtonText: '取消',
					})
					.then(() => {
						this.$store.dispatch('actionCommentDelete', {
							...item
						}).then(res => {
							this.$toast.success('删除成功')
							item.deleteFlag = 1
							item.content = `${item.userName}已删除评论`
						}).catch(console.error)
					})
					.catch(() => {});
			},
			// 点击评论
			onClickComment(item) {
				if (item.replyId && this.$refs.commentReplyList) {
					this.$refs.commentReplyList.open({
						commentId: item.commentId,
						rootId: item.rootId
					})
				}
			},
			// 发表评论完成
			submitComment({
				commentStatus,
				commentInfo
			}) {
				if (commentStatus === 'EDIT') {
					const comment = this.commentData.filter(comment => comment.commentId === commentInfo.commentId)[0]
					if (comment) {
						comment.content = commentInfo.content
						comment.attachmentList = commentInfo.attachmentList
					}
				} else {
					this.commentData.unshift(commentInfo)
				}
				if (!this.subscribe) {
					this.onClickSubscribeChange('OPEN')
				}
			},

			// 回复列表关闭，需要刷新一下评论列表
			replyListClose() {
				this.fetchCommentList()
			},

			openFileAccessRecords(fileUrl) {
				if (this.$refs.fileAccessRecords) {
					this.$refs.fileAccessRecords.open(fileUrl)
				}
			},

			// 获取回复的评论
			fetchSourceComment(commentId) {
				return this.commentData.filter(comment => comment.commentId === commentId)[0]
			},
			// 获取回复的评论的字符串内容
			fetchSourceContent(commentId) {
				const comment = this.fetchSourceComment(commentId)
				if (!comment) {
					return ''
				}
				let content = getSimpleText(this.formatCommentContent(comment))
				content += comment.content.includes('<img') ? '【图片】' : ''
				content += comment.content.includes('<video') ? '【视频】' : ''
				if (!content) {
					if (comment.attachmentList && comment.attachmentList.length) {
						content = '【附件】'
					}
				}
				return content
			},
			fetchCommentList() {
				this.$store.dispatch('actionCommentList', {
						instanceId: this.instanceId,
						commentType: 'INSTANCE'
					})
					.then(res => {
						this.commentData.splice(0, this.commentData.length, ...res)
						return this.$store.dispatch('actionCommentSubscribeGet', {
							instanceId: this.instanceId
						})
					})
					.then(res => {
						this.subscribe = res.subscribe
						return this.$store.dispatch('actionCommentSubscribeList', {
							instanceId: this.instanceId
						})
					})
					.then(res => {
						this.subscribeMemberList = res.member
						this.subscribeExtList = res.external
					})
					.catch(console.error)
			},

			// 下载文件
			downloadFile(file) {
				this.downloadEle.setAttribute('download', file.fileName)
				this.downloadEle.setAttribute('href', `${file.fileUrl}?userId=${this.$store.state.userInfo.userId}`)
				this.downloadEle.click()
			},
			previewFile(val, file) {

				if (['#icon-WAV', '#icon-mp', '#icon-tupian'].includes(fileType2FileImage(file.fileType))) {
					this.previewData = val ? val.map(file => {
						return {
							id: file.id,
							title: file.fileName,
							type: file.fileType,
							href: file.fileUrl,
							poster: '',
							thumbnail: file.fileUrl
						}
					}).filter(item => ['#icon-WAV', '#icon-mp', '#icon-tupian'].includes(fileType2FileImage(item
						.type))) : []
					this.previewData.forEach((item, idx) => {
						if (item.id === file.id) {
							this.index = idx
						}
					})
					const comment = document.getElementById('comment')
					comment.style.transform = 'translate3d(100%, 0px, 0px)'
					console.log('previewFile', comment, this.previewData, this.index)
					return
				}
				if (this.$refs.filePreviewPopup) {
					this.$refs.filePreviewPopup.open(file, 'MIX_FORM')
				}

			},
			formatCommentContent(item) {
				const fields = {}
				Object.keys(this.$store.getters.userListMap).forEach(userId => {
					const user = this.$store.getters.userListMap[userId]
					fields[userId] = {
						envVarName: userId,
						fieldTitle: user.nickname,
					}
				})
				Object.keys(this.$store.getters.extMap).forEach(userId => {
					const user = this.$store.getters.extMap[userId]
					fields[userId] = {
						envVarName: userId,
						fieldTitle: user.orgUserName,
					}
				})
				const varList = Object.keys(fields)
				const str = item.content
				const newStr = str.replace(new RegExp(`\\$(${varList.join('|')})\\$`, "ig"), (fieldTxt, fieldId, idx) => {
					const field = fields[fieldId]
					return `<span style="color: #1b9aee; margin-right: 10px;">@${field.fieldTitle}</span>`
				})
				return newStr
			},

			// 当前人员自己订阅或者取消订阅
			onClickSubscribeChange(subscribe) {
				this.$store.dispatch('actionCommentSubscribeChange', {
						instanceId: this.instanceId,
						subscribe
					})
					.then(res => {
						this.$toast.success('设置成功')
						// const members = this.$store.state.userList.map(user => user.userId)
						if (subscribe === 'OPEN') {
							this.subscribe = 1
							if (this.$store.getters.adminInfo.isMember && !this.subscribeMemberList.includes(this
									.$store.getters.userId)) {
								this.subscribeMemberList.push(this.$store.getters.userId)
							} else {
								if (!this.subscribeExtList.includes(this.$store.getters.userId)) {
									this.subscribeExtList.push(this.$store.getters.userId)
								}
							}

						} else {
							this.subscribe = 0
							if (members.includes(this.$store.getters.userId)) {
								arrayRemove(this.subscribeMemberList, this.$store.getters.userId)
							} else {
								arrayRemove(this.subscribeExtList, this.$store.getters.userId)
							}
						}
						this.subscribeVisible = false
					})
					.catch(console.error)
			},

			// 更新订阅人员
			updateSubscribeList(val) {
				console.log('updateSubscribeList', this.$refs)
				this.subscribeMemberList.splice(0, this.subscribeMemberList.length, ...val.memberIds)
				this.subscribeExtList.splice(0, this.subscribeExtList.length, ...val.extIds)
				this.$store.dispatch('actionCommentSubscribeListSet', {
					instanceId: this.instanceId,
					subscribeUserList: [...val.memberIds, ...val.extIds]
				}).then(res => {
					this.$toast.success('设置成功')
				}).catch(console.error)
			},
			deleteSubscribeUser(val) {
				console.log('deleteSubscribeUser', val)
				arrayRemove(this.subscribeMemberList, val.member)
				arrayRemove(this.subscribeExtList, val.external)
				this.$store.dispatch('actionCommentSubscribeRemove', {
					instanceId: this.instanceId,
					removeUserIdList: val.member ? [val.member] : [val.external]
				}).then(res => {
					this.$toast.success('设置成功')
				}).catch(console.error)
			}
		}
	}
</script>

<style lang="less">
	.log-component-container {
		height: 100%;
		position: relative;

		.sub-header-container {
			width: 100%;
			height: 46px;
			display: flex;
			align-items: center;
			padding: 5px 10px;
			overflow-x: auto;
			-webkit-overflow-scrolling: touch;
			background-color: #ffffff;
			white-space: nowrap;
			border-bottom: 1px solid #e6e6e6;
			justify-content: space-around;

			.todo-filter-item {
				display: inline-block;
				width: 70px;
				text-align: center;
				line-height: 22px;
				color: rgba(43, 52, 65, .6);
				cursor: pointer;
				border: 1px solid transparent;
				transition: all ease .2s;
				margin-right: 8px;
				margin-top: 6px;
				font-size: 12px;
				border: none;

				&.active {
					color: #4260FA;
					background: #DFE8FF;
					border-radius: 16px;
				}

				&:hover {}
			}
		}

		.log-container {
			overflow: auto;
			height: calc(100% - 84px);
			
			.dete-tx{
				color: #666;
				font-size: 12px;
				margin-bottom: 10px;
			}

			.van-steps {
				background-color: transparent;
			}

			.van-step--vertical {
				padding-right: 20px;
			}

			.log-item-container {
				// box-shadow: 0 3px 3px -2px rgba(0, 0, 0, 0.2), 0 3px 4px 0 rgba(0, 0, 0, 0.14), 0 1px 8px 0 rgba(0, 0, 0, 0.2);
				border-radius: 4px;
				// border: 1px solid #EBEEF5;
				background-color: #FFFFFF;
				overflow: hidden;
				transition: 0.3s;

				.log-item-header {
					box-sizing: border-box;
					display: flex;
					justify-content: space-between;
					padding: 15px 20px;
					font-size: 16px;
				}

				.handle-user-container {
					display: flex;
					justify-content: space-between;
					align-items: center;
					padding: 12px;

					>div {
						display: flex;
						align-items: center;

						>div {
							margin-left: 10px;
							display: flex;
							flex-direction: column;
						}
					}
					
					.van-button{
						border: none;
						min-width: 40px;
						margin-right: 4px;
						img{
							width: 21px;
							vertical-align: middle;
							margin-top: -4px;
						}
					}
				}

				.cost-time-container {
					font-size: 12px;
					color: #9e9e9e;
					margin-top: 5px;
					margin-left: 22px;
				}
			}

			.edit-field-container {
				margin: 20px 0;

				.edit-field-item {
					padding: 10px 20px;
					border-bottom: 1px solid #EBEEF5;

					.field-content {
						margin-top: 10px;
						font-size: 14px;

						strong {
							color: #282828;
						}

						span {
							color: #676767;
						}
					}
				}
			}
		}

		.dynamic-container {
			width: 100%;
			height: calc(100% - 84px);
			overflow: auto;
			padding: 10px;
			-webkit-overflow-scrolling: touch;

			> :first-child {
				padding-top: 0 !important;

				.el-avatar {
					margin-top: 0 !important;
				}
			}

			.dynamic-item {
				padding: 10px 0 10px 8px;
				font-size: 12px;
				position: relative;
				border-bottom: 1px solid #e6e6e6;

				.el-avatar {
					position: absolute;
					top: 0;
					left: 8px;
					width: 24px;
					height: 24px;
					border: 1px solid #e6e6e6;
					margin-top: 10px;
				}

				.dynamic-content {
					padding-left: 40px;
					color: #1F2D3D;

					.user-info {
						display: flex;
						justify-content: space-between;
						padding-top: 4px;

						>div {
							display: flex;

							.name {
								color: #1F2D3D;
								font-size: 14px;
							}

							.status {
								margin-left: 10px;
								color: #91A1B7;
							}
						}

						.time {
							color: #91A1B7;
						}
					}

					.dynamic-info {
						line-height: 18px;

						.dynamic-info-line {
							margin-top: 4px;

							>div {
								word-break: break-all;
								word-wrap: break-word;
							}
						}
					}
				}
			}
		}

		.comment-container {
			width: 100%;
			height: calc(100% - 40px);
			overflow: hidden;
			-webkit-overflow-scrolling: touch;
			position: relative;
			background-color: #ffffff;

			.comment-list-container {
				position: absolute;
				padding: 10px;
				top: 0;
				bottom: calc(50px + 40px);
				left: 0;
				right: 0;
				overflow: auto;

				.discuss-header {
					min-height: 50px;
					display: flex;
					justify-content: space-between;
					align-items: center;
					padding-bottom: 10px;
					margin-bottom: 10px;
					border-bottom: 1px dashed #e6e6e6;

					.subscribe-button {
						width: 100px;
					}

				}

				.comment-item {
					padding: 10px 0 10px 8px;
					font-size: 12px;
					position: relative;
					border-bottom: 1px solid #e6e6e6;

					.el-avatar {
						position: absolute;
						top: 0;
						left: 8px;
						width: 24px;
						height: 24px;
						border: 1px solid #e6e6e6;
						margin-top: 10px;
					}

					.comment-content {
						padding-left: 40px;
						color: #1F2D3D;

						.user-info {
							display: flex;
							justify-content: space-between;
							padding-top: 4px;

							>div {
								display: flex;

								.name {
									color: #1F2D3D;
									font-size: 14px;
								}

								.status {
									margin-left: 10px;
									color: #91A1B7;
								}
							}

							.time {
								color: #91A1B7;
							}
						}

						.comment-info {
							line-height: 18px;

							.comment-text {
								margin-bottom: 10px;
							}

							.el-image {
								width: 100px;
								height: auto;
							}
						}
					}
				}
			}

			.comment-input {
				position: absolute;
				height: 50px;
				bottom: 0;
				left: 0;
				right: 0;

				.form-comment-btn-container {
					bottom: 40px;
				}
			}
		}


		.approve-container {
			width: 100%;
			height: calc(100% - 85px);
			overflow: auto;
			-webkit-overflow-scrolling: touch;
			position: relative;
			background-color: #ffffff;

			.comment-item {
				padding: 10px 0 10px 8px;
				font-size: 12px;
				position: relative;
				border-bottom: 1px solid #e6e6e6;

				.el-avatar {
					position: absolute;
					top: 0;
					left: 8px;
					width: 24px;
					height: 24px;
					border: 1px solid #e6e6e6;
					margin-top: 10px;
				}

				.comment-content {
					padding-left: 40px;
					color: #1F2D3D;

					.user-info {
						display: flex;
						justify-content: space-between;
						padding-top: 4px;

						>div {
							display: flex;

							.name {
								color: #1F2D3D;
								font-size: 14px;
							}

							.status {
								margin-left: 10px;
								color: #91A1B7;
							}
						}

						.time {
							color: #91A1B7;
						}
					}

					.comment-info {
						line-height: 18px;
						white-space: pre-wrap;

						.comment-text {
							margin-bottom: 10px;
							white-space: pre-wrap;
						}

						.el-image {
							width: 100px;
							height: auto;
						}
					}
				}
			}
		}

		.comment-list-item {
			width: 100%;
			display: flex;
			padding-bottom: 10px;
			margin-bottom: 10px;
			border-bottom: 1px dashed #e6e6e6;

			.user-img {
				width: 40px;

				.el-image {
					border-radius: 50%;
				}
			}

			.comment-info {
				width: calc(100% - 40px);

				.reply-container {
					background-color: #F4F4FA;
					padding: 10px;
					display: flex;
					width: 100%;
					cursor: pointer;

					.line {
						width: 3px;
						height: 12px;
						background-color: #909399;
						margin-right: 10px;
					}

					.reply-content {
						font-size: 12px;
						width: calc(100% - 20px);
						color: #909399;
						white-space: nowrap;
						text-overflow: ellipsis;
						overflow: hidden;
						word-wrap: break-word;
					}
				}

				.top {
					display: flex;
					justify-content: space-between;
					align-items: center;

					.user-info {
						display: flex;

						>div {
							font-size: 12px;
							color: #6d6d6d;
							margin-right: 10px;
						}
					}

					.comment-handle {
						display: flex;
						align-items: center;

						.handle-button {
							margin-right: 10px;
						}
					}
				}

				.comment-detail {

					.ql-editor {
						padding: 10px 10px 10px 0;
					}

					.comment-content {
						font-size: 12px;
						color: #333;

						img,
						video {
							max-width: 100%;
						}
					}


					.file__list {
						width: 100%;
						display: flex;
						flex-wrap: wrap;
						list-style: none;
						margin: 0;
						padding: 0;

						>li {
							list-style: none;
							width: calc(100% - 10px);
							min-height: 40px;
							margin: 5px;
							display: flex;
							position: relative;
							border-bottom: 1px solid #e6e6e6;


							>.file__icon {
								text-align: center;

								.icon {
									width: 30px;
									height: 30px;
									vertical-align: -0.15em;
									fill: currentColor;
									overflow: hidden;
									margin-right: 10px;
									margin-top: 5px;
								}
							}

							>.file__info {
								width: calc(100% - 40px);
								display: flex;
								flex-direction: column;

								>.file__info-name {
									line-height: 20px;
									color: #495060;
									font-size: 13px;
									width: 100%;
									white-space: nowrap;
									text-overflow: ellipsis;
									overflow: hidden;
									word-wrap: break-word;
								}

								>.file__info-bottom {
									display: flex;
									justify-content: space-between;
									align-items: center;

									>.file__info-size {
										height: 20px;
										line-height: 20px;
										font-size: 11px;
										color: #909399;
									}

									>.file__info-handle {
										display: flex;
										align-items: center;

										.divider {
											height: 16px;
											width: 1px;
											background-color: #e6e6e6;
											margin: 0 5px;
										}
									}
								}
							}
						}
					}
				}
			}
		}

		.dynamic-empty {
			margin-top: 50px;
			text-align: center;
			font-size: 14px;
			color: #5e6d82;
		}
	}

	.log-detail-popup {
		.edit-field-container {
			margin: 20px 0;

			.edit-field-item {
				padding: 10px 20px;
				border-bottom: 1px solid #EBEEF5;

				.field-content {
					margin-top: 10px;
					font-size: 14px;

					strong {
						color: #282828;
					}

					span {
						color: #676767;
						word-break: normal;
						width: auto;
						display: block;
						white-space: pre-wrap;
						word-wrap: break-word;
						overflow: hidden;
					}
				}
			}
		}
	}

	.subscribe-setting-container {
		margin-top: 10px;

		.subscribe-setting-item {
			margin-bottom: 20px;
			cursor: pointer;

			.subscribe-setting-title {
				display: flex;
				font-size: 14px;
				margin-bottom: 10px;

				i {
					margin-right: 10px;
				}

				>div {
					color: #333333;
				}
			}

			.subscribe-setting-tips {
				color: #6d6d6d;
				font-size: 14px;
				margin-left: 24px;
			}
		}
	}
</style>
